import { connect, mapProps } from '@formily/react';
import { CnSelector as UiCnSelector, } from '@/components/cn-selector';
import { mapSize, mapStatus } from '@/form/__builtins__';
export const CnSelector = connect(UiCnSelector, mapProps(mapSize, mapStatus, { dataSource: true }));
CnSelector.displayName = 'CnSelector';
